import React from 'react'
import { Outlet } from 'react-router-dom'

function MainAllTasks() {
  return (
    <div>
      <Outlet/>
    </div>
  )
}

export default MainAllTasks
